var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{staticClass:"saas-dashboard__plan-badge",attrs:{"bold":"","color":_vm.badgeColor}},[_vm._v("\n  "+_vm._s(_vm.$t(`workspacePlanTier.${_vm.workspaceUsage.plan_tier}`))+"\n  "),(_vm.workspaceUsage.trial_days_left)?_c('small',[_vm._v(_vm._s(_vm.$t('dashboardWorkspacePlanBadge.daysLeft', {
      days: _vm.workspaceUsage.trial_days_left,
    })))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }